import type { RouteRecordRaw } from 'vue-router'

export default <RouteRecordRaw[]>[{
    path: '/saaspcEntry',
    name: 'saaspcEntry',
    component: () => import('../views/index.vue')
},
{
    path: '/forgetPassword',
    name: 'forgetPassword',
    component: () => import('../views/forgetPassword/forgetPassword.vue'),
    meta: {
        title: '忘记密码'
    }
},
{
    path: '/accountList',
    name: 'accountList',
    component: () => import('../views/forgetPassword/accountList.vue'),
    meta: {
        title: '选择账号'
    }
},
{
    path: '/resetPassword',
    name: 'resetPassword',
    component: () => import('../views/forgetPassword/resetPassword.vue'),
    meta: {
        title: '设置新密码'
    }
    },
    {
        path: '/isFirstLogin',
        name: 'isFirstLogin',
        component: () => import('../views/isFirstLogin/isFirstLogin.vue'),
        meta:{
            title:'首次登录'
        }


    },
    {
        path: '/integralPage',
        name: 'integralPage',
        component: () => import('../views/integral/index.vue'),
        meta:{
            title:''
        }
    },
    {
        path: '/integralDetail',
        name: 'integralDetail',
        meta: {
          title: '积分账单明细'
        },
        component: () => import('../views/integral/integralDetail.vue')
      },
    {
        path: '/aggMallPc',
        name: 'aggMallPc',
        meta: {
          title: '聚合页'
        },
        component: () => import('../views/aggMall/index.vue')
      },
]


